module.exports = __webpack_public_path__ + "static/media/language_class_video.4ca0d830.mp4";